<div class="login">
  @if (!isLoading()) {
    <div class="login-content">
      <div class="login-wrapper">
        <img class="top-image" src="assets/images/login-logo.png" alt="Header Logo" tabindex="0" />
        <h2>{{ 'pages.login.title' | translate }}</h2>
        <button class="primary" (click)="handleLogin()">
          {{ 'pages.login.login' | translate }}
        </button>
      </div>
      <img class="bottom-image" src="assets/images/FINANSE-ES+NEXT+NAP_BLACK.svg" alt="sponsors" />
    </div>
  } @else {
    <app-spinner [isLoading]="true" />
  }
</div>
